import {DESIGN_SLIDE_TYPES} from '@learningblocks/exp-constants/lib/Utilities';
import {
  slideOneSetAsNextStep,
  slideTwoSetAsNextStep,
  slideThreeSetAsNextStep,
} from './index';

export const setAsNextStep = (params) => {
  switch (params.type) {
    case DESIGN_SLIDE_TYPES.ONE:
      return slideOneSetAsNextStep(params.optionId);
    case DESIGN_SLIDE_TYPES.TWO:
      return slideTwoSetAsNextStep({componentID: params.optionId});
    case DESIGN_SLIDE_TYPES.THREE:
      return slideThreeSetAsNextStep(params.optionId);
  }
};
